import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { radioInputDataReducer } from 'Components/Forms/FormReducers/RadioInputReducer';
import { selectInputDataReducer } from 'Components/Forms/FormReducers/SelectInputReducer';
import { checkboxInputDataReducer } from 'Components/Forms/FormReducers/CheckboxInputReducer';

import { useReducer, useRef } from "react";

var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};

export function GetTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}

export function GetNumberInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength, maxValue, minValue }) {
    var numberInputObj = {
        type: 'number',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength),
            maxValue: getVarValue(maxValue),
            minValue: getVarValue(minValue)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: getVarValue(isInvalid),
            errors: getVarValue(errors),
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, numberInputObj);
}


export function GetRadioInputObj ({ id, name, value, radioButtons, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, inline }) {
    var radioInputObj = {
        type: 'radio',
        id: id,
        name: name,
        value: value,
        radioButtons: radioButtons,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    return ans[x].value;
                }
            }
            return '';
        }
    };

    return useReducer(radioInputDataReducer, radioInputObj);
}

export function GetCheckboxInputObj ({ id, name, value, checkBoxes, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, customGetDisabledOn, inline }) {
    var checkInputObj = {
        type: 'checkbox',
        id: id,
        name: name,
        value: value,
        checkBoxes: checkBoxes,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            inline: inline
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            var checked = [];
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isChecked==true){
                    checked.push(ans[x].value);
                }
            }
            if(checked.length==0){
                return null;
            }
            else {
                return checked;
            }
            
        }
    };

    return useReducer(checkboxInputDataReducer, checkInputObj);
}


export function GetSelectInputObj ({ optGroups, id, name, value, options, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes }) {
    var selectInputObj = {
        type: 'select',
        id: id,
        name: name,
        value: value,
        options: options,
        optGroups: optGroups,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null),
        getValue: (ans) => {
            //console.log(ans);
            for(var x = 0 ; x<ans.length ; x++){
                if(ans[x].isSelected==true){
                    return ans[x].value;
                }
            }
            return null;
        }
    };

    return useReducer(selectInputDataReducer, selectInputObj);
}

export function GetTableauReportTextInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case 'tableauReportName':
            return GetTextInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Report Name',
                description: ()=> {
                    return (
                        <span>
                            {'Report Name should not exceed 100 characters in length.'}
                                <br></br>
                            {'Report Name should not have improper characters \ / : & * ? ” < > | .'}
                        </span>
                    )
                },
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
    }

}

export function GetTableauReportSelectInputData (fieldName, fieldValue) {
   switch (fieldName) {
        
        case 'tableauReportWorkbook':
            return GetSelectInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Workbook',
                description: '',
                title: '',
                placeholder: 'Select Workbook',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'tableauReportWorkbookView':
            return GetSelectInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                options: [
                    {
                        id: "",
                        name: null,
                        displayValue: "Select Workbook View",
                        value: -1,
                        title: null,
                        isChecked: true
 
                    },
                ],
                label: 'Default Workbook View',
                description: '',
                title: '',
                placeholder: 'Select Workbook View',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: true,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'tableauReportCategory':
            return GetSelectInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Report Category',
                description: '',
                title: '',
                placeholder: 'Select Report Category',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'tableauReportCFSetting':
            return GetSelectInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Common Formats Setting',
                description: '',
                title: '',
                placeholder: 'Select Common Formats Setting',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
        case 'tableauReportCFVersion':
            return GetSelectInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                options: [],
                label: 'Common Formats Version',
                description: '',
                title: '',
                placeholder: 'Select Common Formats Version',
                required: false,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: []
            });
   }
}


export function GetTableauReportRadioInputData (fieldName, fieldValue, inline) {
    switch (fieldName) {
        case "tableauReportStatus":
            return GetRadioInputObj({
                id: "tableauReport_" + fieldName,
                name: "tableauReport_" + fieldName,
                value: '',
                radioButtons: [
                    {
                        id: "active",
                        label: "Active",
                        name: "selectedStatus",
                        value: 1,
                        title: "",
                        isChecked: fieldValue==1 ? true : false
                    },
                    {
                        id: "inactive",
                        label: "Inactive",
                        name: "selectedStatus",
                        value: 0,
                        title: "",
                        isChecked: fieldValue==0 ? true : false
                    }
                ],
                label: 'Report Status',
                description: '',
                title: "",
                placeholder: "",
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: inline != null ? inline : true,
                getValue: (ans) => {
                    //console.log(ans);
                    var checked = null;
                    for(var x = 0 ; x<ans.length ; x++){
                        if(ans[x].isChecked==true){
                            checked=ans[x].value;
                        }
                    }
                    
                    return checked; 
                }
            });
    }
}


export function GetTableauReportNumberInputData (fieldName, fieldValue ) {
    switch (fieldName) {

        case 'tableauReportDispOrder':
            return GetNumberInputObj({
                id: 'document_' + fieldName,
                name: 'document_' + fieldName,
                value: fieldValue,
                label: 'Report Display Order',
                description: 'Report Display Order should be between 0.00 and 999.99 (i.e. 1.23).',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                hideFieldOrgTypes: [],
                maxLength: null,
                maxValue: 999.99,
                minValue: 0.00
            });
    }
}

export function GetTableauReportCheckboxInputData (fieldName, fieldValue) {

    switch (fieldName) {
       
        case 'tableauReportOrgAccess':
            return GetCheckboxInputObj({
                id: 'tableauReport_' + fieldName,
                name: 'tableauReport_' + fieldName,
                value: fieldValue,
                checkBoxes: [
                    {
                        id: "psoCheckBox",
                        label: "PSO",
                        title: null,
                        name: "pso",
                        value: "pso",
                        isChecked: false
                    },
                    {
                        id: "ahrqCheckBox",
                        label: "AHRQ",
                        title: null,
                        name: "ahrq",
                        value: "ahrq",
                        isChecked: false
                    },
                    {
                        id: "psoppcCheckBox",
                        label: "PSOPPC",
                        title: null,
                        name: "psoppc",
                        value: "psoppc",
                        isChecked: false
                    }
                ],
                label: 'Assign Organization Access',
                description: '',
                title: '',
                placeholder: '',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                inline: false
            });
     }
}
